import {DumpsterFireSymbol, DumpsterFireSymbolStates} from "../reels/DumpsterFireSymbol";
import {ISymbolPosition} from "../../core/reel/simplereel/IReelData";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";

export class DFSymbolUtils {
    public static createSymbol(symbolName: string, state: DumpsterFireSymbolStates, symbolPositionData?: ISymbolPosition): DumpsterFireSymbol {
        return new DumpsterFireSymbol(symbolName).init(state);
    }

    public static shake(x: number, y: number, hertz: number, intensity: number, duration: number): gsap.core.Timeline {
        let startPosY: number,
            startPosX: number,
            t: boolean = true;
        const tl: gsap.core.Timeline = gsap.timeline({
            onStart: () => {
                startPosY = NolimitApplication.pixiApp.stage.y;
                startPosX = NolimitApplication.pixiApp.stage.x;
            },
            onComplete: () => {
                NolimitApplication.pixiApp.stage.x = startPosX;
                NolimitApplication.pixiApp.stage.y = startPosY;
            },
            onUpdate: () => {
                const lt: number = Math.random() * 2,
                    et: number = Math.random();
                if (t) {
                    t = false;
                    return;
                }
                NolimitApplication.pixiApp.stage.y = startPosY + Math.cos(lt * hertz) * (intensity * et) * y;
                NolimitApplication.pixiApp.stage.x = startPosX + (Math.sin(lt * hertz) * (intensity * et)) * x;
            }
        });
        tl.to(NolimitApplication.pixiApp.stage, {duration: duration});
        return tl;
    }
}